// =============================================================================
// FEATURES.JS — Switches for work that is built but not released yet.
// =============================================================================
// A flag here is a deliberate hold, not a permanent setting: flip it to true,
// deploy, and delete the flag once the feature is simply part of the app.
// =============================================================================

// Agents seeing their own commission — the "My commissions" card on their
// dashboard and the Reports → Commission Payments tab.
//
// ON since 4 Nov 2026. Every agent now reads their own pay: the status of each
// of their contracts, which months cleared their monthly qualifier and which
// forfeited, what is payable, and the deals behind every paycheck. Each of them
// sees only their own line — enforced in the database, not just on screen, by
// the restrictive policies in 20261104_own_payouts_only.sql.
//
// Admins keep the whole picture: Commission Payouts compares every agent, and
// the dashboard panel still flips through the team one agent at a time.
export const SHOW_COMMISSIONS_TO_AGENTS = true
